<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import HeaderAccount from './header/HeaderAccount.vue';
import HeaderNav from './header/HeaderNav.vue';
</script>

<template>
  <header class="main-header">
    <div class="app-header-cnt">
      <router-link to="/">
        <BackstageIcon class="header-logo" data-cy="onHeaderLogo" name="black-logo" />
      </router-link>
      <HeaderNav />
      <HeaderAccount />
    </div>
  </header>
</template>

<style scoped lang="scss">
.main-header {
  width: 100%;
  background-color: var(--primary-bg-color);

  .app-header-cnt {
    @include main-max-with;

    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    height: 4rem;
    padding: 0 1.25rem;

    .header-logo {
      width: 2.0625rem;
      height: 2.0625rem;
    }
  }
}
</style>
